var map = {
	"./alone.svg": 4527,
	"./aperitif.svg": 733,
	"./cheese.svg": 6583,
	"./dessert.svg": 9497,
	"./fish.svg": 4115,
	"./meal.svg": 346,
	"./meat.svg": 9480,
	"./present.svg": 6917,
	"./vegetables.svg": 5312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9841;